import { Controller } from '@hotwired/stimulus';

export class NavigationController extends Controller {
    declare readonly mobileMenuTarget: HTMLElement
    declare readonly mobileMenuButtonTarget: HTMLElement
    declare readonly mobileMenuOpenIconTarget: HTMLElement
    declare readonly mobileMenuCloseIconTarget: HTMLElement

    static targets = [
        "mobileMenu",
        "mobileMenuButton",
        "mobileMenuOpenIcon",
        "mobileMenuCloseIcon"
    ]

    declare mobileMenuOpenValue: boolean
    declare userMenuOpenValue: boolean
    static values = {
        mobileMenuOpen: Boolean,
        userMenuOpen: Boolean
    }

    private boundHandleOutsideClick!: (event: Event) => void

    connect(): void {
        this.boundHandleOutsideClick = this.handleOutsideClick.bind(this)
        document.addEventListener('click', this.boundHandleOutsideClick)
    }

    disconnect(): void {
        document.removeEventListener('click', this.boundHandleOutsideClick)
    }

    toggleMobileMenu(): void {
        this.mobileMenuOpenValue = !this.mobileMenuOpenValue
    }

    closeMobileMenu(): void {
        this.mobileMenuOpenValue = false
    }

    mobileMenuOpenValueChanged(): void {
        this.updateMobileMenuVisibility()
    }

    private updateMobileMenuVisibility(): void {
        if (this.mobileMenuOpenValue) {
            this.mobileMenuTarget.classList.remove('hidden')
            this.mobileMenuOpenIconTarget.classList.add('hidden')
            this.mobileMenuOpenIconTarget.classList.remove('block')
            this.mobileMenuCloseIconTarget.classList.remove('hidden')
            this.mobileMenuCloseIconTarget.classList.add('block')
            this.mobileMenuButtonTarget.setAttribute('aria-expanded', 'true')
        } else {
            this.mobileMenuTarget.classList.add('hidden')
            this.mobileMenuOpenIconTarget.classList.remove('hidden')
            this.mobileMenuOpenIconTarget.classList.add('block')
            this.mobileMenuCloseIconTarget.classList.add('hidden')
            this.mobileMenuCloseIconTarget.classList.remove('block')
            this.mobileMenuButtonTarget.setAttribute('aria-expanded', 'false')
        }
    }

    private handleOutsideClick(event: Event): void {
        const target = event.target as HTMLElement
        
        if (this.mobileMenuOpenValue && !this.element.contains(target)) {
            this.closeMobileMenu()
        }
    }
}